import script from "./Pane9.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane9.vue?vue&type=script&setup=true&lang=js"

import "./Pane9.vue?vue&type=style&index=0&id=2ddf1bee&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ddf1bee"]])

export default __exports__